import Ajax from '../ajax'

export default {
  list: (params) => Ajax('get', 'offcialsite/article/list', params),
  detail: (params) => Ajax('get', 'offcialsite/article', params)
}
